enum ContainerOrFieldType {
    Container = 'Container',
    Field = 'Field',
}

export default ContainerOrFieldType;
